export enum dispatchTypes {
    ALL_STOPS = 'ALL_STOPS',
    ACTIVE_TRUCKS = 'ACTIVE_TRUCKS',
    SUBITEM_DATA = 'SUBITEM_DATA',
    LOADS_DATA = 'LOADS_DATA',
    SPOTTED_DATA = 'SPOTTED_DATA',
    RELOAD_TABLES_ON_TENDER = "RELOAD_TABLES_ON_TENDER",
    LOAD_EDRAY_ORDERS = 'LOAD_EDRAY_ORDERS',
    HIDE_ROWS_ON_TENDER = "HIDE_ROWS_ON_TENDER",
}